import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-deleteicon',
  templateUrl: './deleteicon.component.html',
  styleUrls: ['./deleteicon.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class DeleteiconComponent implements OnInit {

  @Input() type: string;
  @Input() description: string;
  @Input() class: string;
  @Input() data: string;
  @Input() routerLink: any;
  @Input() title: string;
  @Output() callFunction = new EventEmitter();
  @Input() disabled: boolean

  constructor() { }

  ngOnInit(): void {
  }


  onClick(event) {
    this.callFunction.emit('I am button');
  }


}
